export default "__VITE_ASSET__DYkNqSgt__"